import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Navbar, Nav, Container, NavDropdown, Button } from 'react-bootstrap'; // React Bootstrap components

// Custom hook to handle login state based on sessionStorage
function useLoginStatus() {
  const [isLoggedIn, setIsLoggedIn] = useState(() => {
    // Initialize state from sessionStorage or default to false
    return sessionStorage.getItem('isLoggedIn') === 'true';
  });

  useEffect(() => {
    // Watch for changes in sessionStorage
    const onStorageChange = () => {
      setIsLoggedIn(sessionStorage.getItem('isLoggedIn') === 'true');
    };

    // Listen for storage events (e.g., when sessionStorage is changed in another tab)
    window.addEventListener('storage', onStorageChange);

    return () => {
      // Clean up the listener when the component is unmounted
      window.removeEventListener('storage', onStorageChange);
    };
  }, []);

  return [isLoggedIn, setIsLoggedIn];
}

function CustomNavbar() {
  const [isLoggedIn, setIsLoggedIn] = useLoginStatus(); // Use custom hook

  const handleLogout = () => {
    // Remove login status from sessionStorage and update the state
    sessionStorage.removeItem('isLoggedIn');
    setIsLoggedIn(false); // Update state to reflect the logout
    window.location.href = '/login'; // Redirect to login page
  };

  return (
    <Navbar bg="dark" variant="dark" expand="lg" sticky="top">
      <Container>
        {/* Brand */}
        <Navbar.Brand>
          <Link to="/" style={{ color: 'white', textDecoration: 'none' }}>Home</Link>
        </Navbar.Brand>

        {/* Hamburger menu for mobile */}
        <Navbar.Toggle aria-controls="navbar-nav" />

        {/* Navbar collapse for mobile and desktop */}
        <Navbar.Collapse id="navbar-nav">
          <Nav className="ml-auto" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            {/* Tour related links grouped under a dropdown */}
            <NavDropdown title="Tours" id="tour-dropdown" style={{ color: 'white' }}>
              <NavDropdown.Item>
                <Link to="/Tours" style={{ color: 'black', textDecoration: 'none' }}>Create a new Tour</Link>
              </NavDropdown.Item>
              <NavDropdown.Item>
                <Link to="/ManageTours" style={{ color: 'black', textDecoration: 'none' }}>Manage Tours</Link>
              </NavDropdown.Item>
            </NavDropdown>

            {/* Car related links grouped under a dropdown */}
            <NavDropdown title="Cars" id="car-dropdown" style={{ color: 'white' }}>
              <NavDropdown.Item>
                <Link to="/ManageCars" style={{ color: 'black', textDecoration: 'none' }}>Manage Cars</Link>
              </NavDropdown.Item>
              <NavDropdown.Item>
                <Link to="/AddCars" style={{ color: 'black', textDecoration: 'none' }}>Add Rent a Car</Link>
              </NavDropdown.Item>
            </NavDropdown>

            {/* Conditionally render Login or Logout button */}
            {isLoggedIn ? (
              <Nav.Item>
                <Button variant="outline-light" className="ml-2" onClick={handleLogout}>Logout</Button>
              </Nav.Item>
            ) : (
              <Nav.Item>
                <Link to="/login">
                  <Button variant="outline-light" className="ml-2">Login</Button>
                </Link>
              </Nav.Item>
            )}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default CustomNavbar;
